export default "__VITE_ASSET__25c06418__"